// @flow
import React from 'react'
import ImageCropper from './ImageCropper'
import styled, { type StyledComponent } from 'styled-components'
import type { Crop, ImageConfig } from '../types'
import getDefaultCrop from '../getDefaultCrop'
import type { Node } from 'react'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  vertical-align: top;
`
const Title: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
  color: #000;
  margin: 0 0 2px;
`

type Props = {|
  image: Object,
  config: ImageConfig,
  crop: ?Crop,
  title: string | Node,
  height?: number,
  onChange: (Crop) => void
|}

export default function PreviewImageCropper(props: Props) {
  const { image, height, config, title } = props

  return (
    <Wrapper>
      {typeof title === 'string' ? <Title>{props.title}</Title> : title}
      <ImageCropper
        image={image}
        crop={props.crop || getDefaultCrop(image.width, image.height, config.sizesRelation)}
        config={props.config}
        height={height}
        onCrop={(data) => props.onChange(data)}
      />
    </Wrapper>
  )
}
